import { render, staticRenderFns } from "./GraficoLinhasDashboard.vue?vue&type=template&id=04706d2a&scoped=true&lang=pug"
import script from "./GraficoLinhasDashboard.vue?vue&type=script&lang=js"
export * from "./GraficoLinhasDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04706d2a",
  null
  
)

export default component.exports